import { MeteringType, MeteringFilterType } from '@enums';
import { MeteringSubFilter } from './metering-sub-filter.model';

export class MeteringFilter {
  id: number;
  filterId: number;
  name: string;
  subtitle: string;
  meteringType: MeteringType;
  filterType: MeteringFilterType;
  containsMeteringPointIds: number[];

  subfilter: MeteringSubFilter;

  public static initalState = (meteringType: MeteringType): MeteringFilter => {
    return <MeteringFilter>{
      id: -1,
      filterId: -1,
      name: 'All',
      subtitle: '',
      meteringType: meteringType,
      filterType: MeteringFilterType.Unfiltered,
      containsMeteringPointIds: [],
      subfilter: MeteringSubFilter.init('', meteringType, [])
    };
  };
}
